import React, { useState } from "react";
import RequiredStar from "../required-star/RequiredStar";
import RequiredStarOther from "../required-star/RequiredStarOther";
import InformationInfo from "../information-info/InformationInfo";
import Functions from "../../utils/Functions";
import Color from "../../styles/Color";
import injectSheet from "react-jss";
import classNames from "classnames";
import ExtraInfo from "../other/ExtraInfo";
import { isInternFieldOnly, hasExternPermissions } from "../../utils/helpers";
import * as _ from "lodash";

const extraInfoLabel = ["tillganglighetsbidrag", "kulturform"];

export function Label(props) {
  const [isExternUser] = useState(
    _.get(props, "arrangemang.avdelning.id", false)
      ? hasExternPermissions(props.arrangemang.avdelning.id)
      : false
  );
  const {
    classes,
    className,
    collectionType,
    showFillWarning = false,
    tooltipId,
  } = props;
  let hasValue = false;
  let star = null;
  let d = undefined;
  const showExtraInfo = extraInfoLabel.includes(props.name);

  if (props.messages)
    d = props.messages.find((mess) => mess.property === props.name);
  if (props.notArrangemang || !props.arrangemang) {
    // om t ex schema deltagare osv
    if (d) star = <RequiredStarOther description={d.description} />;
  } else if (props.arrangemang) {
    const obj = props.arrangemang[props.name];

    if (obj && Object.prototype.hasOwnProperty.call(obj, "id") && obj.id)
      hasValue = true;
    else if (obj) hasValue = true;
    if (!hasValue && d) {
      star = (
        <RequiredStar
          arrangemang={props.arrangemang}
          description={d.description}
          starColor={{ color: d.optional ? Color.orange() : Color.red() }}
        />
      );
    }
  }

  const checkIfInternFieldOnly = (fieldNo) => {
    if (
      fieldNo &&
      isInternFieldOnly(fieldNo) &&
      !isExternUser &&
      showFillWarning
    ) {
      return (
        <span style={{ color: "grey", wordBreak: "break-word" }}>
          (Fylls i av studieförbundet)
        </span>
      );
    }
  };

  const info = (
    <InformationInfo
      name={props.name}
      hasValue={hasValue}
      tooltipId={tooltipId}
      isKultur={
        props.arrangemang ? Functions.isKultur(props.arrangemang) : false
      }
      isAfv={props.arrangemang ? Functions.isAfv(props.arrangemang) : false}
      informations={props.informations}
    />
  );
  return props.label && props.label.includes("c/o") ? (
    <div className={classes.label}>
      {props.label} {star} {info}
    </div>
  ) : (
    <div
      className={classNames(
        classes.labelContainer,
        showExtraInfo && classes.extraInfoContainer
      )}
    >
      <label className={classNames(classes.label, className)}>
        {props.label ? props.label : props.name}{" "}
        {checkIfInternFieldOnly(collectionType ? collectionType : props.name)}
      </label>
      {star && <div className={classes.starIcon}>{star}</div>}
      {info}{" "}
      {showExtraInfo && (
        <ExtraInfo extraInfoData={getExtraInfoProperties(props.name)} />
      )}
    </div>
  );
}

const styles = {
  label: {
    wordBreak: "break-word",
    fontWeight: 500,
    fontSize: "14px",
    marginBottom: "8px",
  },
  starIcon: {
    marginLeft: "4px",
  },
  labelContainer: {
    display: "flex",
  },
  extraInfoContainer: {
    "& $starIcon": {
      marginBottom: "10px",
    },
    // "& $info": {
    //   marginLeft: "5px",
    // },
  },
};

export default injectSheet(styles)(Label);

function getExtraInfoProperties(infoName) {
  if (infoName === "tillganglighetsbidrag") {
    return {
      name: infoName,
      endPoint: "/tillganglighetsbidrag",
      title: "Tillgänglighetsbidrag",
    };
  } else if (infoName === "kulturform") {
    return {
      name: infoName,
      title: "Beskrivning av kulturformer",
    };
  } else {
    return { name: infoName };
  }
}
